import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MDBBtn, MDBNav, MDBNavItem, MDBNavLink, MDBTabPane, MDBTabContent, MDBIcon, MDBCol, MDBCardBody, MDBCard, MDBCardText, MDBRow, MDBTable, MDBTableHead, MDBTableBody, MDBContainer } from 'mdbreact';
import { ObtenerListaMarcasTecdocEnAPI, ActualizarReglasMarcasGruposMontajeEnAPI, ObtenerGruposMontajeMarcasTecdocEnAPI, abortFetch } from "../../action/actionCreatorsRequests"
import 'antd/dist/antd.css';

import { Drawer, Row, Col, Select, Modal, Checkbox, Button } from 'antd';
import { MSGERROR, MSGOK, traducirPagina } from "../../librerias/funciones"
import {
    CloseOutlined,
    SearchOutlined,
    SaveOutlined
} from '@ant-design/icons';
import MantenimientoMarcas from '../MantenimientoMarcas.jsx';
import MantenimientoMarcaTecdoc from '../MantenimientoMarcaTecdoc';
const { Option } = Select;


const FichaCruceMarcaVehiculo = ({ props, configApp, codmotorizacion }) => {
    const [hayMarcasVehiculo, setHayMarcasVehiculo] = React.useState(false);
    const [obtenerMarcasVehiculo, setObtenerMarcasVehiculo] = React.useState([]);
    const [obtenerMarcasVehiculoAux, setObtenerMarcasVehiculoAux] = React.useState([]);

    const [obtenerGrupos, setObtenerGrupos] = React.useState([]);
    const [obtenerGruposAux, setObtenerGruposAux] = React.useState([]);

    const [abriMantenimientoMarcas, setAbriMantenimientoMarcas] = React.useState(false);
    const [abriMantenimientoMarcasTecdoc, setAbriMantenimientoMarcasTecdoc] = React.useState(false);


    const [txtMarca, setTxtMarca] = React.useState("");

    const [marcaActual, setMarcaActual] = React.useState({});

    const [grupoSeleccionado, setGrupoSeleccionado] = React.useState([]);

    const [marcasActuales, setMarcasActuales] = React.useState([]);

    const [payLoadLocal, setPayLoadLocal] = React.useState(
        {
            ID_MARCA_TECDOC: ""
        }
    )

    const [modalCompra, setModalCompra] = React.useState({
        ABRIR_MODAL: false,
        REGISTRO_SELECCIONADO: {},
        LOADER_PEDIDO: false,
        RESPUESTA_PEDIDO: ""

    });



    const gestionarMarcas = (registros) => {
        let marcas = ""
        registros.map((marca) => {
            marcas += `${marca.MARCA} | `
        })
        setMarcasActuales(registros)
        payLoadLocal.ID_MARCA_TECDOC = marcas;
        setPayLoadLocal(payLoadLocal)
    }


    const modelarDatos = (marcas) => {
        let listaMarca = [];
        let objetoNuevoMarcas = [];
        let contAux = 0;

        for (var i = 0; i < marcas.length; i++) {
            contAux += 1;
            if (contAux <= 3) {
                listaMarca.push({ "Codigo": marcas[i].ID, "Marca": marcas[i].MARCA, "Imagen": "" })
                if ((marcas.length - 1) === i) {
                    objetoNuevoMarcas.push({ "lista": listaMarca });
                }
            } else {
                objetoNuevoMarcas.push({ "lista": listaMarca });
                contAux = 0;
                listaMarca = []
                i = (i - 1)
            }
        }
        return objetoNuevoMarcas.length === 0 ? null : objetoNuevoMarcas;
    }


    const modelarDatosGrupo = (marcas) => {
        let listaMarca = [];
        let objetoNuevoMarcas = [];
        let contAux = 0;

        for (var i = 0; i < marcas.length; i++) {
            contAux += 1;
            if (contAux <= 2) {
                listaMarca.push({ "ID": marcas[i].ID, "NOMBRE": marcas[i].NOMBRE, "Imagen": "" })
                if ((marcas.length - 1) === i) {
                    objetoNuevoMarcas.push({ "lista": listaMarca });
                }
            } else {
                objetoNuevoMarcas.push({ "lista": listaMarca });
                contAux = 0;
                listaMarca = []
                i = (i - 1)
            }
        }
        return objetoNuevoMarcas.length === 0 ? null : objetoNuevoMarcas;
    }



    const buscarEnTabla = (palabraABuscar) => {
        let palabra = palabraABuscar.target.value;
        if (palabra !== "") {
            if (obtenerMarcasVehiculoAux !== null) {
                let resultadoFiltro = obtenerMarcasVehiculoAux.filter((item) => {
                    return item.MARCA.toUpperCase().includes(palabra.toUpperCase()) ||
                        item.MARCA.toUpperCase() === palabra.toUpperCase()
                })
                if (resultadoFiltro.length > 0) {
                    setObtenerMarcasVehiculo(modelarDatos(resultadoFiltro));
                } else {
                    setObtenerMarcasVehiculo(null);
                }

            }
        } else {
            setObtenerMarcasVehiculo(modelarDatos(obtenerMarcasVehiculoAux));
        }
    }


    const buscarGruposMontaje = (ID_MARCA) => {
        setObtenerGrupos([]);

        ObtenerGruposMontajeMarcasTecdocEnAPI(ID_MARCA).then(marcas => {
            if (marcas.REGISTROS !== undefined && marcas.REGISTROS !== null && marcas.REGISTROS.length > 0) {
                setObtenerGrupos(modelarDatosGrupo(marcas.REGISTROS));
                setObtenerGruposAux(marcas.REGISTROS)
            } else {
                setObtenerMarcasVehiculo(null);

                setObtenerGrupos(null);
                setObtenerGruposAux([])
            }
        })
    }


    const grupoSeleccionadoActual = (registro, estaSeleccionnado) => {

        if (grupoSeleccionado.length === 0) {
            setGrupoSeleccionado([registro])
        } else {

            let existeGrupo = grupoSeleccionado.filter((ITEM) => ITEM.ID === registro.ID)
            if (existeGrupo.length === 0) {
                if (estaSeleccionnado) {
                    //añadir
                    let recuperarDatos = [...grupoSeleccionado];
                    recuperarDatos.push(registro)
                    setGrupoSeleccionado([...recuperarDatos])
                } else {
                    //eliminnar
                    let nuevaLista = grupoSeleccionado.filter((eliminnar) => eliminnar.ID !== registro.ID)
                    setGrupoSeleccionado([...nuevaLista])

                }
            } else {
                //eliminnar
                let nuevaLista = grupoSeleccionado.filter((eliminnar) => eliminnar.ID !== registro.ID)
                setGrupoSeleccionado([...nuevaLista])
            }
        }
    }


    const gestionarCruce = async () => {

        if (Object.keys(marcaActual).length > 0) {
            if (grupoSeleccionado.length > 0) {
                if (payLoadLocal.ID_MARCA_TECDOC !== null && payLoadLocal.ID_MARCA_TECDOC !== "") {
                    //const { ID } = grupoSeleccionado[0]
                    let MARCAS_DESTINO = ""
                    let GRUPOS_DESTINO = ""

                    marcasActuales.map((marca) => {
                        MARCAS_DESTINO += `${marca.ID};`
                    })

                    grupoSeleccionado.map((grupo) => {
                        GRUPOS_DESTINO += `${grupo.ID};`
                    })

                    modalCompra.ABRIR_MODAL = true
                    modalCompra.LOADER_PEDIDO = true
                    setModalCompra({ ...modalCompra })

                    let respuesta = await props.CALCULAR_CRUCE(marcaActual.Codigo, GRUPOS_DESTINO, MARCAS_DESTINO)

                    if (respuesta === undefined || respuesta === null) {
                        modalCompra.RESPUESTA_PEDIDO = traducirPagina("Peticion_terminada");

                    } else {
                        if (respuesta.OK) {

                            modalCompra.RESPUESTA_PEDIDO = traducirPagina("Cruce_ralizado");

                            props.CERRAR_FICHA(false)

                        } else {
                            modalCompra.RESPUESTA_PEDIDO = respuesta.MENSAJE_ERROR;
                        }
                    }

                    modalCompra.LOADER_PEDIDO = false
                    setModalCompra({ ...modalCompra })


                } else {
                    MSGERROR(traducirPagina("Mag_marca_destino"))
                }
            } else {
                MSGERROR(traducirPagina("Seleccionar_grupo_varios"))
            }
        } else {
            MSGERROR(traducirPagina("Seleccionar_una_marca"))
        }

    }

    

    const seleccionarMarcas = () => {
        let SELECCIONADOS = []

        if (obtenerGruposAux.length === grupoSeleccionado.length) {
            setGrupoSeleccionado(SELECCIONADOS)

        } else {
            setGrupoSeleccionado(obtenerGruposAux)
        }
    }

    const mostrarSeleccionado = (ID_SELECCIONADO) => {

        let ESTADO = false;
        let RESULTADO = grupoSeleccionado.find((registro) => registro.ID === ID_SELECCIONADO)
        if (RESULTADO !== undefined) {
            ESTADO = true
        }
        return ESTADO
    }


    if (!hayMarcasVehiculo && props.ABRIR_FICHA) {
        setHayMarcasVehiculo(true)
        setAbriMantenimientoMarcas(true)

        ObtenerListaMarcasTecdocEnAPI(10000, 1, 1, "A", null).then(marcas => {
            if (marcas.REGISTROS !== undefined && marcas.REGISTROS !== null && marcas.REGISTROS.length > 0) {
                setObtenerMarcasVehiculoAux(marcas.REGISTROS);
                setObtenerMarcasVehiculo(modelarDatos(marcas.REGISTROS));


            } else {
                setObtenerMarcasVehiculo(null);
            }
        })


    } else {
        if (!props.ABRIR_FICHA && hayMarcasVehiculo) {
            setObtenerMarcasVehiculo([])
            setHayMarcasVehiculo(false)
            if (document.getElementById("buscadorMarcaVeh") !== null) {
                document.getElementById("buscadorMarcaVeh").value = "";
            }
        }
    }

    return (
        <div>
            <Drawer
                width={"50%"}
                onClose={() => { props.CERRAR_FICHA(false) }}
                visible={props.ABRIR_FICHA}
                placement={"right"}
                closable={false}
                bodyStyle={{ padding: '0px' }}
                style={{ zIndex: '999', color: '#fff' }}>


                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => { props.CERRAR_FICHA(false) }}></CloseOutlined>
                        <div> {props.title}</div>
                    </div>
                </div>





                <div className="p-3">
                    <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>
                        <Col md={24}>
                            <span>{traducirPagina("Indique_marca")} </span>
                        </Col>

                        <Col md={24}>
                            <div className="mdb-skin">
                                <div style={{ fontSize: '16px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start' }}>
                                    <div style={{ width: '89%' }}>
                                        <input disabled={true} value={txtMarca} className="form-control" type="text" aria-label="Search" placeholder={traducirPagina("Seleccion_marca")} style={{ backgroundColor: "#f1f1f1", border: '0px', height: '100%', color: '#000', padding: '10px', borderRadius: '4px 0px 0px 4px' }} autoComplete="off" onChange={(e) => { buscarEnTabla(e); setTxtMarca(e.target.value) }} />
                                    </div>

                                    <div style={{ backgroundColor: '#f1f1f1', width: '5%' }}>
                                        <MDBBtn id="closeBuscadorMarcaVeh" onClick={e => {
                                            setTxtMarca("");
                                            setObtenerGrupos([]);
                                            setMarcaActual({})

                                            setAbriMantenimientoMarcas(true)

                                        }} style={{ border: '0', padding: '10px', margin: '0', boxShadown: 'none', visibility: txtMarca !== "" ? 'visible' : 'hidden' }} className="btn-matriculav2">  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </MDBBtn>
                                    </div>
                                    <div style={{ backgroundColor: '#f1f1f1', width: '1%' }}>
                                        <div className="barraLateral" style={{ height: '33px' }} ></div>
                                    </div>
                                    <div style={{ backgroundColor: '#f1f1f1', width: '5%' }}>
                                        <MDBBtn onClick={e => { setAbriMantenimientoMarcas(true) }} style={{ border: '0', padding: '10px 10px 10px 10px', margin: '0', boxShadown: 'none' }} className="btn-matricula">  <SearchOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </MDBBtn>

                                    </div>
                                </div>

                            </div>
                        </Col>

                        <Col md={24}>
                            <div className='container_cruce_ref_grupo_montaje'>
                                <span>{traducirPagina("Msg_filtro_un_grupo_marca")} </span>

                                <div className='select_todas_marca' onClick={() => { seleccionarMarcas() }}>{traducirPagina("Todas")}</div>
                            </div>

                        </Col>

                        <Col md={24}>
                            {
                                <div className='body_grupo_mont' >
                                    {obtenerGrupos === null ?
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '70vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                        :
                                        obtenerGrupos.length > 0 ?
                                            obtenerGrupos.map((item, i) =>
                                                <div style={{ padding: '5px', fontSize: '14px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start' }}>

                                                    {item.lista.map((row, i) =>
                                                        <div style={{ width: '50%' }} key={row.ID} >
                                                            <Checkbox checked={mostrarSeleccionado(row.ID)} onChange={(e) => { grupoSeleccionadoActual(row, e.target.checked) }} > {row.NOMBRE} </Checkbox>
                                                        </div>
                                                    )}

                                                </div>
                                            )
                                            :
                                            (Object.keys(marcaActual).length > 0) ?

                                            obtenerGrupos === null ?
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '70vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                            :
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '70vh', color: '#000' }}> <div color="mdb-color darken-3" className="spinner-border  fast" role="status" disabled /> </div>
                                        :
                                        null

                                            
                                    }
                                </div>
                            }
                        </Col>

                        <Col md={24}>
                            <span>{traducirPagina("Msg_filtro_indique_marca")} </span>
                        </Col>

                        <Col md={24}>
                            <div className="mdb-skin">
                                <div style={{ fontSize: '16px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start', marginBotton: '10px' }}>
                                    <div style={{ width: '89%' }}>
                                        <input disabled={true} name="ID_MARCA_TECDOC" value={payLoadLocal.ID_MARCA_TECDOC} className="form-control" type="text" aria-label="Search" placeholder={"Seleccione las marcas pinchando en la lupa"} style={{ backgroundColor: "#f1f1f1", border: '0px', height: '100%', color: '#000', padding: '10px', borderRadius: '4px 0px 0px 4px' }} autoComplete="off" onChange={(e) => { payLoadLocal.ID_MARCA_TECDOC = e.target.value; setPayLoadLocal({ ...payLoadLocal }) }} />
                                    </div>

                                    <div style={{ backgroundColor: '#f1f1f1', width: '5%' }}>
                                        <MDBBtn id="closeBuscadorMarcaVeh" onClick={e => {
                                            payLoadLocal.ID_MARCA_TECDOC = ""
                                            setMarcasActuales([])

                                            setAbriMantenimientoMarcasTecdoc(true)

                                        }} style={{ border: '0', padding: '10px', margin: '0', boxShadown: 'none', visibility: payLoadLocal.ID_MARCA_TECDOC !== "" ? 'visible' : 'hidden' }} className="btn-matriculav2">  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </MDBBtn>
                                    </div>
                                    <div style={{ backgroundColor: '#f1f1f1', width: '1%' }}>
                                        <div className="barraLateral" style={{ height: '33px' }} ></div>
                                    </div>
                                    <div style={{ backgroundColor: '#f1f1f1', width: '5%' }}>
                                        <MDBBtn onClick={e => { setAbriMantenimientoMarcasTecdoc(true) }} style={{ border: '0', padding: '10px 10px 10px 10px', margin: '0', boxShadown: 'none' }} className="btn-matricula">  <SearchOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </MDBBtn>
                                    </div>
                                </div>

                            </div>

                        </Col>


                        <Col md={24}>

                            <div className="menu_mantenimiento" style={{ padding: '10px 0px' }}>
                                <div className="mantenimiento_item1"></div>
                                <div className="mantenimiento_item2">
                                    <div className="botonNuevo" style={{ backgroundColor: 'var(--azul-claro-serca)', color: '#fff' }} onClick={() => {
                                        gestionarCruce()
                                    }}>
                                        <SaveOutlined /> {traducirPagina("Calcular")}
                                    </div>
                                </div>
                            </div>

                        </Col>
                    </Row>
                </div>
            </Drawer >


            {
                abriMantenimientoMarcas ?
                    <MantenimientoMarcas
                        title={traducirPagina("Msg_cruce_referencia_grupo")}
                        ABRIR_FICHA={abriMantenimientoMarcas}
                        CERRAR_FICHA={setAbriMantenimientoMarcas}
                        MARCA_SELECCIONADA={setTxtMarca}
                        MARCA_ACTUAL={setMarcaActual}
                        ID_SOCIO={props.ID_SOCIO}
                        BUSCAR_GRUPO={buscarGruposMontaje}
                        HAY_HARACA_SELECCIONADA={txtMarca.trim() !== "" ? true : false}
                        CERRAR_FICHA_PADRE={props.CERRAR_FICHA}
                    >
                    </MantenimientoMarcas>
                    :
                    null
            }


            {
                abriMantenimientoMarcasTecdoc ?
                    <MantenimientoMarcaTecdoc
                        title={traducirPagina("Msg_seleccion_marca")}
                        ABRIR_FICHA={abriMantenimientoMarcasTecdoc}
                        CERRAR_FICHA={setAbriMantenimientoMarcasTecdoc}

                        MARCA_SELECCIONADA={gestionarMarcas}
                        MARCAS={payLoadLocal.ID_MARCA_TECDOC}
                        MARCAS_ALMACEN={marcasActuales}
                        ID_SOCIO={props.ID_SOCIO}
                        HAY_MARCA_SELECCIONADA={payLoadLocal.ID_MARCA_TECDOC.trim() !== "" ? true : false}
                        CERRAR_FICHA_PADRE={props.CERRAR_FICHA}
                    >
                    </MantenimientoMarcaTecdoc>
                    :
                    null
            }


            {modalCompra.ABRIR_MODAL ?
                <Modal
                    visible={modalCompra.ABRIR_MODAL}
                    style={{ zIndex: "9999" }}
                    width={700}
                    centered
                    afterClose={() => {
                        setModalCompra({
                            ABRIR_MODAL: false,
                            REGISTRO_SELECCIONADO: {},
                            LOADER_PEDIDO: false,
                            RESPUESTA_PEDIDO: ""
                        })

                    }}
                    title={traducirPagina("Msg_cruce_referencia_grupo")}
                    onCancel={() => {
                        if (!modalCompra.LOADER_PEDIDO) {
                            modalCompra.ABRIR_MODAL = false
                            modalCompra.REGISTRO_SELECCIONADO = {}
                            modalCompra.LOADER_PEDIDO = false
                            modalCompra.RESPUESTA_PEDIDO = ""

                            setModalCompra({ ...modalCompra })
                        }
                    }}
                    footer={[

                    ]}>

                    <Row style={{ color: '#000', fontSize: '18px', fontWeight: '500' }}>
                        <Col md={24} className="mb-2">
                            <span style={{ color: '#000' }}>{
                                modalCompra.RESPUESTA_PEDIDO === "" ?
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '10vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled />  {`${traducirPagina("Msg_generando_cruce")} ...`} </div>
                                    :
                                    modalCompra.RESPUESTA_PEDIDO

                            }</span>
                            <br></br>


                            <div className='btn_cruceReferencia_alert' onClick={() => { abortFetch() }}>
                                {traducirPagina("Cancelar_peticion")}
                            </div>
                        </Col>
                    </Row>
                </Modal>
                :
                null
            }


        </div>

    )
}

FichaCruceMarcaVehiculo.propTypes = {
    title: PropTypes.string,
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    ID_SOCIO: PropTypes.number,
    CALCULAR_CRUCE: PropTypes.func,

};

const mapStateToProps = (state, props) => {
    return {
        codmotorizacion: state.codmotorizacion,
        configApp: state.configApp,
        props: props,

    };
}

export default connect(mapStateToProps)(FichaCruceMarcaVehiculo);